// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 6350 ? "72a30a16" : chunkId) + "." + {"2442":"4dac6e2fea1e9802","6350":"8953ab1dc1b48182","7856":"32f753b1966e0850"}[chunkId] + ".js";
};